

class MessageEvent extends Event {
	constructor(message) {
		super("message")
		this.data = message;
	}
}

const getLinesOfCell = (count, lines, x, y) => {
	const al = [];
	for(let l of lines) {
		if((l.x===x || l.x===x+1) && l.y===y && l.isH || l.x===x && (l.y===y || l.y===y+1) && !l.isH) {
			al.push(l);
		}
	}
	return al;
}

const getCells = (count, lines, existingCells) => {
	const cells = [];
	for(let i=0; i<count; i++) {
		for(let j=0; j<count; j++) {
			const ls = getLinesOfCell(count, lines, i, j);
			if(ls.length===4) {
				let latestLine = null;
				for(const line of ls) {
					if(!latestLine || line.time > latestLine.time)
						latestLine = line;
				}
				cells.push({x: i, y: j, pid: latestLine.pid});
			}
		}
	}
	if(existingCells) {
		const newCells = [];
		for(let i of cells) {
			if(!existingCells.find(j => j.x===i.x && j.y===i.y))
				newCells.push(i);
		}
		return newCells;
	}
	return cells;
}

const nextTurn = (lines, count, people, turn, hasCells) => {
	if(lines.length===2*count*(count+1))
		return null;
	if(hasCells)
		return turn;
	const turnIndex = turn!==null?people.findIndex(p => p.pid===turn):people.length-1;
	let nextTurnIndex;
	for(let i=1; i<=people.length; i++) {
		nextTurnIndex = (turnIndex+i)%people.length;
		if(!people[nextTurnIndex].dead) return people[nextTurnIndex].pid;
	}
	return people[nextTurnIndex].pid;
}


export default class OnlineController extends EventTarget {
	constructor({name, socket, gameid, count}) {
		super();
		this.initData = {name, socket, gameid, count};
		this.count = count;
		setTimeout(() => {
			this.ws = new WebSocket(socket)
			this.ws.addEventListener('open', () => {
				this.dispatchEvent(new Event('open'));
			});
			this.ws.addEventListener('close', () => {
				this.dispatchEvent(new Event('close'));
			});
			this.ws.addEventListener('message', (e) => {
				const data = JSON.parse(e.data);
				if(data.type==='accepted') {
					this.self = data.person.pid;
					data.person.self = true;
					const params = new URLSearchParams();
					params.set('socket', this.initData.socket);
					params.set('gameid', data.game.gameid);
					this.url = window.location.origin + window.location.pathname + '?' + params.toString();
				} else if(data.type==='turn' && data.pid === this.self)
					data.sensors = true;
				this.dispatchEvent(new MessageEvent(data));
			});
		}, 100);
	}
	init() {
		if(typeof this.initData.gameid === 'number')
			this.send({type: 'join', name: this.initData.name, gameid: this.initData.gameid})
		else
			this.send({type: 'create', name: this.initData.name, count: this.initData.count});
	}
	send(data) {
		this.ws.send(JSON.stringify(data));
	}
}
